export const eventDocumentListSelector = state =>
  state.getIn(['app', 'events', 'event', 'documentList', 'data']).toJS();
export const eventDocumentListStateSelector = state =>
  state.getIn(['app', 'events', 'event', 'documentList']).toJS().state;
export const eventDataSelector = state =>
  state.getIn(['app', 'events', 'event', 'event', 'data']).toJS();
export const eventDataStateSelector = state =>
  state.getIn(['app', 'events', 'event', 'event']).toJS().state;
export const eventTagsDataSelector = state =>
  state.getIn(['app', 'events', 'event', 'tags', 'data']).toJS();
export const eventObjectsDataSelector = state =>
  state.getIn(['app', 'events', 'event', 'objects', 'data']).toJS();
export const persistsSelector = state =>
  state.getIn(['app', 'events', 'event', 'persists']).toJS();
export const lastPositionSelector = state =>
  state.getIn(['app', 'events', 'event', 'lastPosition']);
export const lastTopPositionSelector = state =>
  state.getIn(['app', 'events', 'event', 'lastTopPosition']);
export const uploadedImagesSelector = state =>
  state.getIn(['app', 'events', 'event', 'uploadedImages', 'data']).toJS();
export const uploadedImagesStateSelector = state =>
  state.getIn(['app', 'events', 'event', 'uploadedImages']).toJS().state;
export const linkedImagesSelector = state =>
  state.getIn(['app', 'events', 'event', 'linkedImages', 'data']).toJS();
export const linkedImagesStateSelector = state =>
  state.getIn(['app', 'events', 'event', 'linkedImages']).toJS().state;
export const linkedImageSelector = state =>
  state.getIn(['app', 'events', 'event', 'linkedImage', 'data']).toJS();
export const linkedImageStateSelector = state =>
  state.getIn(['app', 'events', 'event', 'linkedImage']).toJS().state;
export const linkedEventsSelector = state =>
  state.getIn(['app', 'events', 'event', 'linkedEvents', 'data']).toJS();
export const linkedEventsStateSelector = state =>
  state.getIn(['app', 'events', 'event', 'linkedEvents']).toJS().state;
